import { render, staticRenderFns } from "./ClinicalFileUpload.vue?vue&type=template&id=f3c79490&scoped=true"
import script from "./ClinicalFileUpload.vue?vue&type=script&lang=js"
export * from "./ClinicalFileUpload.vue?vue&type=script&lang=js"
import style0 from "./ClinicalFileUpload.vue?vue&type=style&index=0&id=f3c79490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c79490",
  null
  
)

export default component.exports